module.exports = __webpack_public_path__ + "img/wx1.b8420c05.jpg";